import name from './name'

const selectSliceData = state => state[name]

const selectSkillBites = state => selectSliceData(state).skillBites

const selectSkillBiteLanguage = state => selectSliceData(state).languages

export { selectSkillBites, selectSkillBiteLanguage }
